import DashCard from "./dash-card.jsx";

const columnsClass = {
    1: "col-span-1",
    2: "col-span-2",
    3: "col-span-3",
    4: "col-span-4",
    5: "col-span-5",
    6: "col-span-6",
    7: "col-span-7",
    8: "col-span-8",
    9: "col-span-9",
    10: "col-span-10",
    11: "col-span-11",
    12: "col-span-12",
    13: "col-span-13",
    14: "col-span-14",
    15: "col-span-15",
    16: "col-span-16",
    17: "col-span-17",
    18: "col-span-18",
    19: "col-span-19",
    20: "col-span-20",
    21: "col-span-21",
    22: "col-span-22",
    23: "col-span-23",
    24: "col-span-24",
};

export default function MetricDashCard({
    counterCard,
    diagonal = false,
    diagonalCounter = false,
    title,
    value,
    colSpan = 1,
    width,
    height,
    dashClassName = "",
    pClassName = "",
    h2ClassName = "",
}) {
    return (
        <DashCard
            counterCard={counterCard || diagonalCounter}
            width={width}
            height={height}
            className={`
                metric-dash-card
                ${diagonal ? "metric-dash-card-diagonal text-center" : ""}
                ${diagonal ? "px-1! pt-3! pb-4!" : "px-4! py-3!"}
                ${diagonalCounter ? "diagonal-counter-card" : ""}
                ${columnsClass[colSpan] ?? columnsClass[1]}
                ${dashClassName}
            `}
        >
            {diagonal ? (
                <>
                    <h2 className={`text-(length:--font-lg)! 2xl:text-(length:--font-xl)! text-[#F4FFFF]! font-bold ${h2ClassName}`}>
                        {value}
                    </h2>
                    <p className={`text-(length:--font-sm)! 2xl:text-(length:--font-md)! text-[#AAAAAA]! mb-1! font-light! ${pClassName}`}>
                        {title}
                    </p>
                </>
            ) : (
                <>
                    <p className={`text-(length:--font-sm)! 2xl:text-(length:--font-md)! text-[#AAAAAA]! mb-1! font-light! ${pClassName}`}>
                        {title}
                    </p>
                    <h2 className={`text-(length:--font-lg)! 2xl:text-(length:--font-xl)! text-[#F4FFFF]! font-semibold! ${h2ClassName}`}>
                        {value}
                    </h2>
                </>
            )}
        </DashCard>
    )
}
